import { http } from '../api/http';
import type { User } from '../context/AuthContext';

type LoginOk = { user: User; token: string };
type LoginMFA = { mfaRequired: true; mfaToken: string };

type RegisterOk = { user: User; token: string };
type RegisterMFASetup = { mfaSetupRequired: true; setupToken: string; otpauthUrl: string; qrSvg?: string | null };

export const AuthService = {
  login(email: string, password: string) {
    return http<LoginOk | LoginMFA>('/auth/login', {
      method: 'POST',
      auth: false,
      body: { email, password }
    });
  },

  verifyMfa(mfaToken: string, code: string) {
    return http<LoginOk>('/auth/mfa/verify-login', {
      method: 'POST',
      auth: false,
      body: { tempToken: mfaToken, code }
    });
  },

  register(payload: { name: string; email: string; password: string }) {
    return http<RegisterOk | RegisterMFASetup>('/auth/register', {
      method: 'POST',
      auth: false,
      body: payload
    });
  },

  registerAdmin(payload: { name: string; email: string; password: string }) {
    return http<RegisterOk | RegisterMFASetup>('/auth/register/admin', {
      method: 'POST',
      auth: false,
      body: payload
    });
  },

  confirmMfaSetup(setupToken: string, code: string) {
    return http<RegisterOk>('/auth/mfa/setup/confirm', {
      method: 'POST',
      auth: false,
      body: { setupToken, code }
    });
  },

  logout(reason: 'LOGOUT' | 'EXPIRED' = 'LOGOUT') {
    return http<{ message: string }>('/auth/logout', {
      method: 'POST',
      body: { reason }
    });
  }
};
